import React, { FunctionComponent } from 'react';
import InputBox from '@components/InputBox';
import InputPasswordBox from '@components/InputPasswordBox';
import ButtonDefault from '@components/ButtonDefault';
import { Path, SubmitHandler, useForm } from 'react-hook-form';
import { ISignInFormProps } from '@containers/App/user/auth/form/signIn/redux';
import { ISignIn } from '@modules/auth/types';
import { setCookie } from '@modules/common/tools/cookie';
import Router from 'next/router';
import { defer } from 'lodash';
import config from '@configs/app';
import Link from 'next/link';


const SignInForm: FunctionComponent<ISignInFormProps> = (props) => {
  const { login, translate, currentLanguage } = props;
  const { register, handleSubmit, formState: { errors } } = useForm<ISignIn>();
  const loginError = false;

  const onSubmit: SubmitHandler<ISignIn> = (data) => {
    login(data, currentLanguage).then(({ token, role }) => {
      setCookie('token', token || '');
      defer(() => Router.replace(role === 'teacher' ? config.public.myDay : config.private.redirectPage));
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="sing-form show">
      <div className="input-group">
        <InputBox<ISignIn>
          register={register}
          tabIndex={1}
          autoComplete="on"
          error={'error login'}
          required={true}
          errorsObj={errors}
          label={translate('loginInputEmail')}
          name="email"
          id="email"
        />
        <InputPasswordBox<ISignIn>
          register={register}
          tabIndex={2}
          autoComplete="on"
          error={'error password'}
          required={true}
          errorsObj={errors}
          label={translate('loginInputPassword')}
          name="password"
          id="password"
        />
      </div>
      {loginError && (
        <div className="input-code-hint error">
          loginError
        </div>
      )}
      <div className="form-bottom">
        <ButtonDefault
          text={translate('buttonTextLogin')}
          type="submit"
          tabIndex={3}
          // disabledClass={isLoad ? 'load' : ((login && password) ? '' : 'disabled')}
          addClass="form-bottom__button" />
        <div className="form-bottom__text">
          <Link href="/auth/recovery">
            <a className="a">
              <span>{translate('buttonTextRecoveryPassword')}</span>
            </a>
          </Link>
        </div>
      </div>
    </form>
  );
};


export default SignInForm;
